import * as React from 'react';
import { IFactoid } from '../../types/project';
import { Factoid } from './components/Factoid';
import * as styles from './Factoids.css';

interface IFactoidsProps {
  factoids: IFactoid[];
}

export const Factoids: React.FC<IFactoidsProps> = ({ factoids }) => {
  return (
    <div className={styles['factoids']}>
      {factoids.map(factoid => (
        <Factoid {...factoid} key={factoid.id} />
      ))}
    </div>
  );
};
